import { useAtomValue } from 'jotai';

import { currentPlayingIdAtom } from '@/shared-ui';

import { audioQueueAtom } from './project-response-audio-queue.atoms';

export function useIsAiAudioActive(): boolean {
  const queue = useAtomValue(audioQueueAtom);
  const currentPlayingId = useAtomValue(currentPlayingIdAtom);

  if (currentPlayingId !== null) return true;
  return queue.some(
    (item) =>
      item.status === 'pending' ||
      item.status === 'loading' ||
      item.status === 'ready'
  );
}
